import * as Sentry from '@sentry/react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { Toaster } from 'sonner';

import { ErrorPage, NotFoundPage } from '@/components/layout';
import type { AuthContextValue } from '@/context/auth/authContext';

export interface MyRouterContext {
  auth: AuthContextValue;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  notFoundComponent: NotFoundPage,
  errorComponent: ErrorPage,
  onCatch: (error: Error) => {
    Sentry.captureException(error);
  },
  component: () => (
    <>
      <Outlet />
      <Toaster position="top-right" richColors />
    </>
  ),
});
